import { Entity } from "./Entity.js";
import { COMBAT_TUNING } from "../data/tuning.js";

export class Projectile extends Entity {
  constructor(scene, x, y, facing, damage, spriteConfig = null, owner = null) {
    const w = spriteConfig?.w || 10;
    const h = spriteConfig?.h || 10;
    super(scene, x - w / 2, y - h / 2, w, h, 1);
    this.setHurtboxProfile("projectile");
    this.speed = (spriteConfig?.speed || 8) * facing;
    this.damage = damage;
    this.lifetime = spriteConfig?.lifetime || 500;
    this.elapsed = 0;
    this.facing = facing;
    this.spriteConfig = spriteConfig;
    this.sprite = null;
    this.owner = owner;
    this.useSprite = !!(spriteConfig?.atlas && spriteConfig?.frame);
    this.rotationSpeed = (spriteConfig?.rotationSpeed ?? 0.012) * facing;
    this.initialRotation = (spriteConfig?.initialRotation ?? 0.08) * facing;
  }

  create() {
    if (this.useSprite) {
      const texture = this.scene.textures.get(this.spriteConfig.atlas);
      if (texture) {
        texture.setFilter(Phaser.Textures.FilterMode.NEAREST);
      }
      this.sprite = this.scene.add.sprite(this.x + this.w / 2, this.y + this.h / 2, this.spriteConfig.atlas, this.spriteConfig.frame)
        .setDepth(950)
        .setFlipX(this.facing === -1);
      this.sprite.setRotation(this.initialRotation);
    } else {
      this.sprite = this.scene.add.graphics().setDepth(950);
      this.drawGraphics();
    }
  }

  drawGraphics() {
    this.sprite.clear();
    this.sprite.fillStyle(0x8B6914, 1);
    this.sprite.fillCircle(this.x + 5, this.y + 5, 5);
    this.sprite.fillStyle(0xA07818, 0.6);
    this.sprite.fillCircle(this.x + 4, this.y + 4, 3);
  }

  update(dt) {
    if (this.markedForRemoval) return;
    const dtScale = this.scene.frameScale || 1;
    this.x += this.speed * dtScale;
    this.elapsed += dt;
    if (this.elapsed >= this.lifetime) {
      this.markedForRemoval = true;
      this.destroy();
      return;
    }
    if (this.useSprite) {
      this.sprite.x = Math.round(this.x + this.w / 2);
      this.sprite.y = Math.round(this.y + this.h / 2);
      this.sprite.rotation += this.rotationSpeed * dtScale;
      this.sprite.setDepth(950 + this.sprite.y);
    } else {
      this.drawGraphics();
      this.sprite.setDepth(950 + this.y + this.h / 2);
    }
  }

  getBounds() {
    const pad = COMBAT_TUNING.projectile.padding;
    return {
      x: this.x - pad,
      y: this.y - pad,
      w: this.w + pad * 2,
      h: this.h + pad * 2,
    };
  }

  destroy() {
    if (this.sprite) {
      this.sprite.destroy();
      this.sprite = null;
    }
  }
}
